// extracted by mini-css-extract-plugin
module.exports = {"text":"portrait-module--text--2g1xy"};